import { Box, Pagination, TablePagination } from "@mui/material";
import { grey } from "@mui/material/colors";

const TanstackFooterPagination = ({ count, page, rowsPerPage, onPageChange, onRowsPerPageChange, height = 40 }) => {
	const pageCount = Math.ceil(count / rowsPerPage);

	return (
		<Box
			sx={{
				height,
				backgroundColor: grey[200],
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-end",
				gap: 1,
				px: 1,
			}}>
			{/* TablePagination: rows per page + range */}
			<TablePagination
				component="div"
				count={count}
				page={page}
				rowsPerPage={rowsPerPage}
				onPageChange={(_, p) => onPageChange(p)}
				// onRowsPerPageChange={onRowsPerPageChange}
				// rowsPerPageOptions={[5, 10, 20, 50, 100]}
				slotProps={{
					select: { sx: { display: "none" } },
				}}
				labelRowsPerPage=""
				ActionsComponent={() => null} //  hides < >
				sx={{
					"& .MuiTablePagination-toolbar": {
						minHeight: height,
						height,
						padding: 0,
					},
					"& .MuiTablePagination-displayedRows": {
						marginRight: 1,
					},
				}}
			/>

			{/* Pagination: page numbers */}
			<Pagination
				count={pageCount}
				page={page + 1}
				onChange={(_, p) => onPageChange(p - 1)}
				size="medium"
				showFirstButton
				showLastButton
			/>
		</Box>
	);
};
export default TanstackFooterPagination;
